import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../common/components/table/agGrid/Table';
import Loader from '@lwt-helix/loader';

export const BreakdownTable = (props) => {
    const {
        tableView,
        rowData,
        tableTitleWithTooltips,
        pinnedBottomRowData,
        externalParams,
        gridRef,
        isLoading,
    } = props;

    return (
        <div className="bg-white mb-3 raised-border mt-12">
            {!isLoading ? (
                <Table
                    gridRef={gridRef}
                    tableView={tableView}
                    rowData={rowData}
                    tableTitleWithTooltips={tableTitleWithTooltips}
                    pinnedBottomRowData={pinnedBottomRowData}
                    externalParams={externalParams}
                    isTableAutoHeight={false}
                />
            ) : (
                <div className="py-3 office-breakdown-wrapper d-flex justify-content-center">
                    <Loader />
                </div>
            )}
        </div>
    );
};

BreakdownTable.propTypes = {
    externalParams: PropTypes.object,
    pinnedBottomRowData: PropTypes.object,
    rowData: PropTypes.array,
    tableTitleWithTooltips: PropTypes.object.isRequired,
    tableView: PropTypes.object,
    gridRef: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
};
